<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>Meeting</li>
  </ul>
  
  <section class="card">
    <div class="card-header meetings-page-header d-flex flex-wrap justify-content-between align-items-center gap-2">
      <span class="cat__core__title mb-0 flex-grow-1 min-w-0">
        <strong>Meeting</strong>
      </span>
      <div class="meetings-header-actions d-flex flex-wrap gap-2 justify-content-end flex-shrink-0">
          <button (click)="add()" class="btn btn-sm btn-primary" type="button" [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}">
            <i class="fa fa-plus"></i>&nbsp;Add Meeting</button>
        <button (click)="addcircular()" class="btn btn-sm btn-primary" type="button" [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}">
          <i class="fa fa-plus"></i>&nbsp;Add Circular Resolution</button>
      </div>
    </div>
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
        <span class="pull-right">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <form class="sf-body">

          <!-- Row 1: Document Type pills + Meeting Type + Meetings Date -->
          <div class="sf-row">
            <div class="sf-inline-group">
              <label class="form-control-label">Document Type</label>
              <div class="sf-doctype-toggle">
                <button type="button" class="sf-pill"
                  [class.sf-pill--active]="SearchType === 'isMeeting'"
                  (click)="SearchType='isMeeting'; CheckProcessType('Meeting')">Meeting</button>
                <button type="button" class="sf-pill"
                  [class.sf-pill--active]="SearchType === 'isCR'"
                  (click)="SearchType='isCR'; CheckProcessType('CR')">Circular Resolution</button>
                <button type="button" class="sf-pill"
                  [class.sf-pill--active]="SearchType === 'isBoth'"
                  (click)="SearchType='isBoth'; CheckProcessType('Both')">Both</button>
              </div>
            </div>
            <div class="sf-col">
              <label class="form-control-label">Meeting Type :</label>
              <select id="drpmeeting" [(ngModel)]="selectedMeeting" class="form-control"
                (ngModelChange)="getMeetingFromType()" [ngModelOptions]="{standalone:true}">
                <option value=null [selected]="true">Select</option>
                <option *ngFor="let meetingTypeList of meetingType" [ngValue]="meetingTypeList._id">
                  {{meetingTypeList.MeetingType}}
                </option>
              </select>
            </div>
            <div class="sf-col">
              <label class="form-control-label">Meetings Date:</label>
              <select class="form-control" [(ngModel)]="meetingsSearch" [ngModelOptions]="{standalone:true}">
                <option value=null [selected]="true">Select</option>
                <option *ngFor="let meeting of meetingDateOnSelectedType" [value]="meeting._id">
                  {{meeting.meetingList.MeetingDate | date: "dd-MM-y"}} {{meeting.meetingList.MeetingTime}}
                </option>
              </select>
            </div>
          </div>

          <!-- Row 2: Meetings Date Range + Search/Clear -->
          <div class="sf-row">
            <div class="sf-inline-group sf-inline-group--grow">
              <label class="form-control-label">Meetings Date Range:</label>
              <div class="sf-daterange">
                <span class="sf-date-label">From:</span>
                <div class="sf-date-field">
                  <app-datepicker-material [(ngModel)]="meetingsSearchDateFrom" [placeholder]="'dd-mm-yyyy'"
                    (ngModelChange)="meetingDateSearchMeeting()" [ngModelOptions]="{standalone: true}">
                  </app-datepicker-material>
                </div>
                <span class="sf-date-label">To:</span>
                <div class="sf-date-field">
                  <app-datepicker-material [(ngModel)]="meetingsSearchDateTo" [placeholder]="'dd-mm-yyyy'"
                    [ngModelOptions]="{standalone: true}">
                  </app-datepicker-material>
                </div>
              </div>
            </div>
            <div class="sf-col sf-col--actions">
              <label class="form-control-label">&nbsp;</label>
              <div class="filter-actions-meetings">
                <button type="button" [disabled]="response" class="btn btn-sm btn-primary"
                  (click)="searchData(selectedMeeting);">
                  <i class="fa fa-search"></i>&nbsp;Search
                </button>
                <button type="button" [disabled]="response" class="btn btn-sm btn-default btn-clear" (click)="clear()">
                  <i class="fa fa-refresh"></i>&nbsp;Clear
                </button>
              </div>
            </div>
          </div>

        </form>
      </div>
    </section>
  
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table id="datatableMeeting" datatable [dtOptions]="dtOptions" class="table table-hover compact cell-border nowrap stripe dataTable"
              >
  
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="modal fade" id="deleteMeetingConfirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
      aria-labelledby="" aria-hidden="true" style="top: 50px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabelForDeletion">
              <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                Are you sure you want to delete meeting?
              </div>
            </div>
            <br>
            <!-- Automatic Meeting Number START -->
            <div class="row">
              <div class="col-md-8">
                This will change the subsequent meeting numbers, do you want to proceed?
              </div>
              <div class="col-md-4">
                <div class="md-radio md-radio-inline">
                    <input id="IsSequenseTue" type="radio" style="position:absolute" name="IsSequenseMeetingNumber"
                        [(ngModel)]="IsSequenseMeetingNumber" [value]="true" class="form-check-input">
                    <label for="IsSequenseTue">Yes</label>
                </div>
                <div class="md-radio md-radio-inline">
                    <input id="IsSequenseFalse" type="radio" style="position:absolute" name=" IsSequenseMeetingNumber"
                        [(ngModel)]="IsSequenseMeetingNumber" [value]="false" class="form-check-input">
                    <label for="IsSequenseFalse">No</label>
                </div>
              </div>
            </div>
            <!-- Automatic Meeting Number END -->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger" (click)="deleteMeeting()" data-dismiss="modal">
              <i class="fa fa-check"></i>&nbsp;Yes</button>
            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
              <i class="fa fa-times"></i>&nbsp;No</button>
          </div>
        </div>
      </div>
    </div>
  
    <div class="modal fade modal-size-medium" id="agendaDocxUploadDialog" tabindex="-1" role="dialog" data-backdrop="static"
      data-keyboard="false" aria-labelledby="" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa fa-upload"></i>
              <span id="AgendaDocumentUploadTitle"></span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
  
              <div class="row">
                <div class="col-md-4">
                  <label class="form-control-label">Agenda Template
                  </label>
                </div>
                <div class="col-md-8">
                  <label class="input-group">
                    <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="templateFileName" accept=".docx">
                    <span class="input-group-addon default" *ngIf="templateFileName" (click)="downloadFile('style')">
                      <i class="fa fa-download"></i>
                    </span>
                    <span class="input-group-addon warning" (click)="uploadTemplate()">
                      <i class="fa fa-upload"></i>
                    </span>
                  </label>
                </div>
  
              </div>
  
              <div class="row" *ngIf="uploadDoc">
  
                <div class="col-md-4">
                  <label class="col-form-label" for="l5">
                    <span>Upload Template
                      <span _ngcontent-c2="" style="color: red;">*</span>
                    </span>
                  </label>
                </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <input type="file" class='form-control fileUpload' (change)="agendaDocsChangeEvent($event)" />
                    <span *ngIf="typeHasError" style="color: red">
                      Only DOCX Type File is allowed to upload.
                    </span>
  
                  </div>
                  <!-- {{fileHasError | json}} -->
  
                </div>
  
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label class="form-control-label">Index Template
                  </label>
                </div>
                <div class="col-md-8">
                  <label class="input-group">
                    <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true" [(ngModel)]="indexTemplateFileName">
                    <span class="input-group-addon default" *ngIf="indexTemplateFileName" (click)="downloadFile('index')">
                      <i class="fa fa-download"></i>
                    </span>
                    <span class="input-group-addon warning" (click)="uploadIndexTemplate()">
                      <i class="fa fa-upload"></i>
                    </span>
                  </label>
                </div>
  
              </div>
              <div class="row" *ngIf="uploadIndexDoc">
  
                <div class="col-md-4">
                  <label class="col-form-label" for="l5">
                    <span>Upload Template
                      <span _ngcontent-c2="" style="color: red;">*</span>
                    </span>
                  </label>
                </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <input type="file" class='form-control fileUpload' (change)="indexDocsChangeEvent($event)" accept=".docx"/>
                    <span style="color: red">
                      Only DOCX Type File is allowed to upload.
                    </span>
  
                  </div>
                  <!-- {{fileHasError | json}} -->
  
                </div>
  
              </div>
  
            </div>
          </div>
          <div class="modal-footer">
  
            <button id="saveAgendaDoc" *ngIf="uploadDoc" type="button" class="btn-sm btn btn-primary" (click)="uploadDocs()">
              <i class="fa fa-save"></i>&nbsp;Upload</button>
  
            <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
              <i class="fa fa-times"></i>&nbsp;Close</button>
  
          </div>
        </div>
      </div>
    </div>

    <app-alert></app-alert>
  </section>
  
  
  
  
